module.exports = __webpack_public_path__ + "static/media/debug.ebfb7910.svg";